const DagensEmailLink = () => {
  return <a href="mailto:info@dagens.farm">info@dagens.farm</a>;
};

export default DagensEmailLink;
